import useAmericanIssuer from "components/company/v3/context/hooks/useAmericanIssuer";
import { FormattedMessage } from "react-intl";

export default function AmericanExternalLinks() {
  const { investorRelationsHref, websiteHref, edgarHref } = useAmericanIssuer();

  return (
    <div className="flex gap-4 divide-gray-200 dark:divide-gray-700 lg:flex-row lg:gap-0 lg:divide-x lg:*:px-2 lg:first:*:pl-0 lg:last:*:pr-0">
      {websiteHref && (
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={websiteHref}
          className="text-sm font-medium text-blue-600 hover:underline dark:text-blue-400"
        >
          <FormattedMessage defaultMessage="Website" id="JkLHGw" />
        </a>
      )}

      {investorRelationsHref && (
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={investorRelationsHref}
          className="text-sm font-medium text-blue-600 hover:underline dark:text-blue-400"
        >
          <FormattedMessage defaultMessage="Site de RI" id="LSwTIE" />
        </a>
      )}

      {edgarHref && (
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={edgarHref}
          className="text-sm font-medium text-blue-600 hover:underline dark:text-blue-400"
        >
          <FormattedMessage defaultMessage="SEC" id="1mNkDf" />
        </a>
      )}
    </div>
  );
}
